import { Typography, Grid, Stack, Rating, Button, Box, useMediaQuery, IconButton } from '@mui/material'
import PromotionalAlert from './dashboardComponents/PromotionalAlert'
import DayUnitToggle from './dashboardComponents/DayUnitToggle'
import { useState } from 'react'
import ExpirySlider from './dashboardComponents/ExpirySlider'
import RemoveIcon from '@mui/icons-material/Remove'
import AddIcon from '@mui/icons-material/Add'
import OpenCaseStatBox from './dashboardComponents/OpenCaseStatBox'
import OtherStatBox from './dashboardComponents/OtherStatBox'

const DashboardV2 = () => {
  const [dayUnit, setDayUnit] = useState('365d')
  const [qualityScore, setQualityScore] = useState(4.5)
  const [expiresIn, setExpiresIn] = useState(20)

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'))

  return (
    <Box
      sx={{
        backgroundColor: 'rgba(241, 243, 246, 1)',
        fontFamily: 'Roboto',
        width: { xl: '100%', lg: '100%', md: '94.5%', sm: '100vw', xs: '100%' },
        minHeight: '100vh',
        padding: '6rem 0rem',
      }}
    >
      <Grid container rowGap={3} px={'1rem'}>
        <Grid item lg={11.7} md={11} sm={11} xs={11.5}>
          <PromotionalAlert />
        </Grid>
        <Grid
          container
          maxWidth={{ lg: '100%', md: '80%', sm: '70%', xs: '100%' }}
          justifyContent={'space-between'}
          alignItems={'center'}
          rowSpacing={isSmallScreen ? 1 : 0}
          pb={isSmallScreen ? 2 : 0}
        >
          <Grid item md={2} sm={12}>
            <Typography
              variant="h4"
              style={{
                color: 'rgba(0, 0, 0, 0.87)',
                fontSize: '1.5rem',
                fontWeight: '600',
                textAlign: 'left',
              }}
            >
              Dashboard
            </Typography>
          </Grid>
          <Grid item md={1.2} sm={12} xs={11.5} justifyContent={'flex-end'}>
            <DayUnitToggle dayUnit={dayUnit} setDayUnit={setDayUnit} />
          </Grid>
        </Grid>
        <Grid
          container
          bgcolor={'#fff'}
          p={3}
          rowSpacing={isSmallScreen ? 2 : 0}
          justifyContent={'space-between'}
          alignItems={'center'}
          borderRadius={'8px'}
          maxWidth={{ lg: '100%', md: '100%', sm: '98%', xs: '95%' }}
          boxShadow={'0px 4px 20px -4px rgba(16, 24, 40, 0.08)'}
        >
          <Grid item md={4} sm={12} xs={12}>
            <Stack
              direction={'row'}
              columnGap={1}
              rowGap={2}
              alignItems={'center'}
              flexWrap={'wrap'}
              justifyContent={'center'}
              sx={{
                border: '1px solid rgba(196, 202, 241, 1)',
                borderRadius: '8px',
                color: 'rgba(100, 118, 140, 1)',
                minHeight: '56px',
                px: 3,
                py: 1,
              }}
            >
              <Typography fontSize={'14px'}>QUALITY OF BUSINESS SCORE</Typography>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Rating
                  name="half-rating-read"
                  value={qualityScore}
                  precision={0.1}
                  sx={{
                    '& .MuiRating-iconFilled': { color: '#3C4FB9' },
                    marginX: '8px',
                  }}
                  max={5}
                  readOnly
                />
                <Typography color={'#3C4FB9'}>{qualityScore}</Typography>
              </div>
            </Stack>
          </Grid>
          <Grid item md={1.8} sm={12} xs={12}>
            <Stack
              direction={'row'}
              spacing={1}
              alignItems={'center'}
              flexWrap={'wrap'}
              justifyContent={'center'}
              sx={{
                border: '1px solid rgba(196, 202, 241, 1)',
                borderRadius: '8px',
                color: 'rgba(100, 118, 140, 1)',
                minHeight: '56px',
                px: 3,
                py: 1,
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Typography
                  color={'#263497'}
                  alignItems={'center'}
                  display={'flex'}
                  fontFamily={'Roboto Slab'}
                  fontSize={'30px'}
                >
                  {23}
                  <Typography component={'span'}>rd</Typography>
                </Typography>
                {/* <sup style={{ color: "#263497" }}>rd</sup> */}
              </div>
              <Typography marginX={'6px'} fontSize={'12px'}>
                of 4973 agents
              </Typography>
            </Stack>
          </Grid>
          <Grid item md={3} sm={12} xs={12}>
            <Stack
              direction={'row'}
              spacing={1}
              alignItems={'center'}
              flexWrap={'wrap'}
              justifyContent={'center'}
              sx={{
                border: '1px solid rgba(196, 202, 241, 1)',
                borderRadius: '8px',
                color: 'rgba(100, 118, 140, 1)',
                minHeight: '56px',
                px: 3,
                py: 1,
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Typography
                  color={'#263497'}
                  alignItems={'center'}
                  display={'flex'}
                  fontFamily={'Roboto Slab'}
                  fontSize={'30px'}
                >
                  {7}%
                </Typography>
                {/* <sup style={{ color: "#263497" }}>rd</sup> */}
              </div>
              <Typography marginX={'6px'} fontSize={'12px'}>
                Applicant non-disclosure Rate
              </Typography>
            </Stack>
          </Grid>
          <Grid item lg={1} md={2} sm={12} xs={12}>
            <Button
              variant="outlined"
              sx={{
                bgcolor: 'transparent',
                borderColor: '#3C4FB9',
                borderRadius: '100px',
                color: '#3C4FB9',
                textTransform: 'none',
              }}
            >
              View Details
            </Button>
          </Grid>
        </Grid>
        <Grid
          container
          md={12}
          xs={11.5}
          bgcolor={'#fff'}
          p={3}
          rowSpacing={isSmallScreen ? 2 : 0}
          justifyContent={'center'}
          alignItems={'flex-start'}
          borderRadius={'8px'}
          maxWidth={{ lg: '100%', md: '100%', sm: '98%', xs: '100%' }}
          boxShadow={'0px 4px 20px -4px rgba(16, 24, 40, 0.08)'}
        >
          <Stack direction={'column'} width={'100%'} gap={1} alignItems={'flex-start'}>
            <Typography mb={1} color={'#64768C'} fontSize={'14px'} fontWeight={'500'}>
              OPEN CASES
            </Typography>
            <Typography fontSize={'12px'}>Cases that expire in</Typography>
            <Stack direction={'row'} width={'100%'} gap={2} alignItems={'center'} justifyContent={'center'} mb={2}>
              <IconButton
                sx={{ bgcolor: '#E7EAFC', color: '#3C4FB9' }}
                onClick={() => setExpiresIn((prev) => prev - 1)}
              >
                <RemoveIcon />
              </IconButton>
              <ExpirySlider value={expiresIn} setValue={(v) => setExpiresIn(v)} />
              <IconButton
                sx={{ bgcolor: '#E7EAFC', color: '#3C4FB9' }}
                onClick={() => setExpiresIn((prev) => prev + 1)}
              >
                <AddIcon />
              </IconButton>
            </Stack>
          </Stack>
          <Grid container columnSpacing={2} rowSpacing={2}>
            <Grid item lg={3} md={3} sm={3} xs={6}>
              <OpenCaseStatBox numberOfCases={33} label={'Approved Incomplete Apps'} />
            </Grid>
            <Grid item lg={3} md={3} sm={3} xs={6}>
              <OpenCaseStatBox numberOfCases={33} label={'Paid Not Signed'} />
            </Grid>
            <Grid item lg={3} md={3} sm={3} xs={6}>
              <OpenCaseStatBox numberOfCases={33} label={'Missing First Payment'} />
            </Grid>
            <Grid item lg={3} md={3} sm={3} xs={6}>
              <OpenCaseStatBox numberOfCases={33} label={'Risk of Lapse'} />
            </Grid>
          </Grid>
        </Grid>
        <Grid container columnGap={2} rowGap={2}>
          <Grid
            item
            xl={5.94}
            lg={5.89}
            md={12}
            sm={11.5}
            xs={11.5}
            bgcolor={'#fff'}
            py={3}
            justifyContent={'space-between'}
            alignItems={'center'}
            borderRadius={'8px'}
            boxShadow={'0px 4px 20px -4px rgba(16, 24, 40, 0.08)'}
          >
            <Stack
              direction={'row'}
              maxWidth={'100%'}
              px={2}
              alignItems={'center'}
              justifyContent={'space-between'}
              mb={1}
            >
              <Typography color={'#64768C'} fontSize={'14px'} fontWeight={'500'} textAlign={'left'}>
                PRODUCT & APPOINTMENT STATUS
              </Typography>
              <Button
                variant="outlined"
                sx={{
                  bgcolor: 'transparent',
                  borderColor: '#3C4FB9',
                  borderRadius: '100px',
                  color: '#3C4FB9',
                  textTransform: 'none',
                  maxHeight: '40px',
                  fontSize: '14px',
                  minWidth: '160px',
                }}
              >
                License Status
              </Button>
            </Stack>
            <Grid container px={2}>
              <Grid item lg={4} md={4} sm={4} xs={4}>
                <OtherStatBox value={33} label={'Product Library'} />
              </Grid>
              <Grid item lg={4} md={4} sm={4} xs={4}>
                <OtherStatBox value={33} label={'Product Eligible'} />
              </Grid>
              <Grid item lg={4} md={4} sm={4} xs={4}>
                <OtherStatBox value={33} label={'Product Access'} />
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xl={5.94}
            lg={5.89}
            md={12}
            sm={11.5}
            xs={11.5}
            bgcolor={'#fff'}
            py={3}
            justifyContent={'space-between'}
            alignItems={'center'}
            borderRadius={'8px'}
            boxShadow={'0px 4px 20px -4px rgba(16, 24, 40, 0.08)'}
          >
            <Stack
              direction={'row'}
              maxWidth={'100%'}
              px={2}
              alignItems={'center'}
              justifyContent={'space-between'}
              mb={1}
            >
              <Typography color={'#64768C'} fontSize={'14px'} fontWeight={'500'} textAlign={'left'}>
                CUSTOMER SUPPORT TICKETS
              </Typography>
              <Button
                variant="outlined"
                sx={{
                  bgcolor: 'transparent',
                  borderColor: '#3C4FB9',
                  borderRadius: '100px',
                  color: '#3C4FB9',
                  textTransform: 'none',
                  fontSize: '14px',
                  minWidth: '160px',
                }}
              >
                View Details
              </Button>
            </Stack>
            <Grid container px={2}>
              <Grid item lg={4} md={4} sm={4} xs={4}>
                <OtherStatBox value={33} label={'Opened'} />
              </Grid>
              <Grid item lg={4} md={4} sm={4} xs={4}>
                <OtherStatBox value={33} label={'In Progress'} />
              </Grid>
              <Grid item lg={4} md={4} sm={4} xs={4}>
                <OtherStatBox value={33} label={'Closed'} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Stack direction={'row'} width={'100%'} px={2} alignItems={'center'} justifyContent={'space-between'} mb={2}>
          <Typography fontSize={'20px'} fontWeight={'700'}>
            Applications
          </Typography>
          <Button
            startIcon={<AddIcon />}
            sx={{
              bgcolor: '#3C4FB9',
              borderColor: '#3C4FB9',
              borderRadius: '100px',
              color: '#fff',
              textTransform: 'none',
              px: 2.5,
              py: 1.2,
            }}
          >
            New Application
          </Button>
        </Stack>
        <Grid container columnGap={2} rowGap={2}>
          <Grid item xl={2.915} lg={2.9} md={2.8} sm={6} xs={5.5}>
            <Stack
              direction={'row'}
              spacing={1}
              alignItems={'center'}
              flexWrap={'wrap'}
              justifyContent={'center'}
              sx={{
                border: '1px solid rgba(196, 202, 241, 1)',
                borderRadius: '8px',
                color: 'rgba(100, 118, 140, 1)',
                minHeight: '56px',
                px: 3,
                py: 1,
                bgcolor: '#fff',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Typography
                  color={'#263497'}
                  alignItems={'center'}
                  display={'flex'}
                  fontFamily={'Roboto Slab'}
                  fontSize={'30px'}
                >
                  {55}%
                </Typography>
                {/* <sup style={{ color: "#263497" }}>rd</sup> */}
              </div>
              <Typography marginX={'6px'} fontSize={'12px'}>
                % of Tickets Closed in 24+ Hours
              </Typography>
            </Stack>
          </Grid>
          <Grid item xl={2.915} lg={2.9} md={2.8} sm={6} xs={5.5}>
            <Stack
              direction={'row'}
              spacing={1}
              alignItems={'center'}
              flexWrap={'wrap'}
              justifyContent={'center'}
              sx={{
                border: '1px solid rgba(196, 202, 241, 1)',
                borderRadius: '8px',
                color: 'rgba(100, 118, 140, 1)',
                minHeight: '56px',
                px: 3,
                py: 1,
                bgcolor: '#fff',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Typography
                  color={'#263497'}
                  alignItems={'center'}
                  display={'flex'}
                  fontFamily={'Roboto Slab'}
                  fontSize={'30px'}
                >
                  {55}%
                </Typography>
                {/* <sup style={{ color: "#263497" }}>rd</sup> */}
              </div>
              <Typography marginX={'6px'} fontSize={'12px'}>
                % of Tickets Closed in 24+ Hours
              </Typography>
            </Stack>
          </Grid>
          <Grid item xl={2.915} lg={2.9} md={2.8} sm={6} xs={5.5}>
            <Stack
              direction={'row'}
              spacing={1}
              alignItems={'center'}
              flexWrap={'wrap'}
              justifyContent={'center'}
              sx={{
                border: '1px solid rgba(196, 202, 241, 1)',
                borderRadius: '8px',
                color: 'rgba(100, 118, 140, 1)',
                minHeight: '56px',
                px: 3,
                py: 1,
                bgcolor: '#fff',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Typography
                  color={'#263497'}
                  alignItems={'center'}
                  display={'flex'}
                  fontFamily={'Roboto Slab'}
                  fontSize={'30px'}
                >
                  {55}%
                </Typography>
                {/* <sup style={{ color: "#263497" }}>rd</sup> */}
              </div>
              <Typography marginX={'6px'} fontSize={'12px'}>
                % of Tickets Closed in 24+ Hours
              </Typography>
            </Stack>
          </Grid>
          <Grid item xl={2.915} lg={2.9} md={2.8} sm={6} xs={5.5}>
            <Stack
              direction={'row'}
              spacing={1}
              alignItems={'center'}
              flexWrap={'wrap'}
              justifyContent={'center'}
              sx={{
                border: '1px solid rgba(196, 202, 241, 1)',
                borderRadius: '8px',
                color: 'rgba(100, 118, 140, 1)',
                minHeight: '56px',
                px: 3,
                py: 1,
                bgcolor: '#fff',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Typography
                  color={'#263497'}
                  alignItems={'center'}
                  display={'flex'}
                  fontFamily={'Roboto Slab'}
                  fontSize={'30px'}
                >
                  {55}%
                </Typography>
                {/* <sup style={{ color: "#263497" }}>rd</sup> */}
              </div>
              <Typography marginX={'6px'} fontSize={'12px'}>
                % of Tickets Closed in 24+ Hours
              </Typography>
            </Stack>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  )
}

export default DashboardV2
